/** GraphQL mutation to send contact information. */

export default `
  mutation sendContactInformation($input: ContactFormInput) {
    sendContactInformation(input: $input)
  }
`
